import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import imageDesktopWebp from './images/business-owner-at-work-desktop.webp';
import imageMobileWebp from './images/business-owner-at-work-mobile.webp';

export default () => (

  <InformationalModule
    // configs
    sectionId='sustainability-impact-financial-access-advancing-business-diversity'
    themeType='lightTheme'
    backgroundVariant='lightB'
    moduleName='financial-planning-module'
    moduleVariation='A'
    reverseContent
    // content
    subHeadingText={<>Improving lives through <WidowBlock>financial security</WidowBlock></>}
    // column content
    columnContentA={(
      <>
        <Typography nextElement='typography'>
          We approach financial planning differently. We ask deeper questions and listen closely. We pursue long&#45;term value over short&#45;term gain. And we have access to a range of exclusive solutions designed to deliver better outcomes.
        </Typography>
        <Typography nextElement='typography'>
          With a network of more than 22,000 financial advisors and team members across hundreds of locations in the United States, we build lifelong relationships with clients, understanding their needs and crafting personalized plans as unique as they are.
        </Typography>
        <Typography nextElement='button'>
          Our comprehensive approach considers both risk management and growth because we believe that optimizing a plan with insurance, investments, and guaranteed income is the best way to help policyowners and clients reach their goals.
        </Typography>
        <Link
          id='sustainability-impact-financial-access-investment-impact-section-link'
          variant='buttonLinkSecondary'
          linkUrl='/financial-planning/'
          ariaLabel='Partner with us to increase financial access'>
          Partner with us
        </Link>
      </>
    )}
    // image props
    imageAltText='Two women conversing near an open car trunk and background activity visible.'
    imageSrcDefault={imageDesktopWebp}
    imageSrcMobile={imageMobileWebp}
  />
);
